import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/src/CSSRulePlugin';
import { SplitText } from 'gsap/src/SplitText';
import { statementFunc } from './aboutAnimations';
gsap.registerPlugin(ScrollTrigger, CSSRulePlugin, SplitText);

// The toggle colou for the header //
export const headerToggle = (state) => {
  const siteHeader = document.querySelector('[data-header="main"]');
  state === true
    ? siteHeader.classList.add('dark-bg')
    : siteHeader.classList.remove('dark-bg');
};

export const logoToggle = (state) => {
  const target = document.querySelector('.site-logo');
  state === true
    ? target.classList.add('dark-bg')
    : target.classList.remove('dark-bg');
};

// Animation to change menu when next to a black bg

export const headerRules = () => {
  const sectionsBlack = gsap.utils.toArray('.section__dark');
  const sectionsLight = gsap.utils.toArray('.section__light');
  if (sectionsBlack.length) {
    setTimeout(() => {
      sectionsBlack.forEach((section) => {
        ScrollTrigger.create({
          start: 'top top',
          trigger: section,
          onEnter: () => headerToggle(true),
          onEnterBack: () => headerToggle(true),
          // markers: true,
        });
        ScrollTrigger.create({
          start: 'top bottom',
          trigger: section,
          onEnter: () => logoToggle(true),
          onEnterBack: () => logoToggle(true),
        });
      });
    }, 500);
  }
  if (sectionsLight.length) {
    setTimeout(() => {
      sectionsLight.forEach((section) => {
        ScrollTrigger.create({
          start: 'top top',
          trigger: section,
          onEnter: () => headerToggle(false),
          onEnterBack: () => headerToggle(false),
          // markers: true,
        });
        ScrollTrigger.create({
          start: 'top bottom',
          trigger: section,
          onEnter: () => logoToggle(false),
          onEnterBack: () => logoToggle(false),
        });
      });
    }, 500);
  }
  gsap.to('.header__logo .logo', {
    scrollTrigger: {
      start: 'top top',
      trigger: '.header__logo',
      scrub: true,
    },
    x: -100,
  });
  gsap.to('.site-logo', {
    scrollTrigger: {
      start: 'top bottom',
      trigger: '.site-footer',
      scrub: true,
    },
    x: 300,
  });
  gsap.from('.site-logo', {
    scrollTrigger: {
      start: 'top top',
      trigger: '.header__logo',
      scrub: true,
      // markers: true,
    },
    x: 300,
  });

  /* Rule for the Team member page to make the header white on load */
  const body = document.querySelector('body');
  if (body.classList.contains('single-team')) {
    headerToggle(true);
  }
};

// // Home Banner //

export const homeBanner = () => {
  const target = document.querySelector('.home__embed-banner');
  if (target) {
    const tl = gsap.timeline();
    tl.set('.scrolling-text__title-1', { opacity: 1 });
    tl.fromTo(
      '.scrolling-text__title-1 .arrow',
      { opacity: 0 },
      { opacity: 1 },
    );
  }
};

// Home Scrolling Text //

export const homeScrollText = () => {
  const target = document.querySelector('[data-scrolling="home"]');
  if (!target) {
    return;
  }

  // Second Statement //
  gsap.set('[data-statement="1"] .w-full', { opacity: 0 });
  gsap.fromTo(
    '[data-statement="1"] .w-full',
    {
      opacity: 0,
      y: 40,
    },
    {
      scrollTrigger: {
        trigger: target,
        start: 'top 80%',
        scrub: true,
      },
      opacity: 1,
      y: 0,
    },
  );
  gsap.to('[data-statement="1"] .w-full', {
    scrollTrigger: {
      trigger: target,
      start: 'top top',
      end: '700%',
      scrub: true,
      // markers: true,
      pin: true,
      pinSpacing: false,
    },
  });
  // tlSecondStat.to();
};

// Brand Images  //

export const brandsScroll = () => {
  const brands = gsap.utils.toArray('.brand-scroll__banner-image');
  if (!brands.length) {
    return;
  }
  brands.forEach((brand) => {
    gsap.set(brand, { opacity: 0 });
    gsap.to(brand, {
      scrollTrigger: {
        start: 'top 90%',
        end: 'top 50%',
        trigger: brand,
        scrub: true,
        // markers: true,
      },
      duration: 1,
      opacity: 1,
    });
  });
};

// Brands Animations //
export const brandsBg = () => {
  const target = document.querySelector('.brands');
  if (!target) {
    return;
  }
  const targetHeight = target.offsetHeight;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: target,
      start: '-35% bottom',
      scrub: true,
      // markers: true,
    },
  });
  tl.to(target, { background: '#ffff' });
  tl.to(target, { background: '#ffff' });
  tl.to(target, { background: '#ffff' });
  tl.to(target, { background: '#f9cbc5' });
  tl.to(target, { background: '#fedd9b' });
  tl.to(target, { background: '#5ded8d' });

  // Temp. Brands Tomorrow text //

  gsap.to('.temp-header', {
    scrollTrigger: {
      trigger: '.temp-header',
      end: targetHeight,
      start: 'top 10%',
      pin: true,
      // markers: true,
      pinSpacing: false,
    },
  });
};

// Second Home Statements //

export const homeScrollTextBottom = () => {
  const target = document.querySelector('[data-scrolling="home-bottom"]');
  if (!target) {
    return;
  }

  // Mobile Sizes for animations
  let title2Start;
  if (window.matchMedia('(min-width: 768px)').matches) {
    title2Start = 'top -10%';
  } else {
    title2Start = 'top -15%';
  }

  gsap.to('.scrolling-text__title-2', {
    scrollTrigger: {
      trigger: '.scrolling-text__title-2',
      end: '+=3700',
      start: title2Start,
      pin: true,
      // markers: true,
      pinSpacing: false,
    },
  });

  const dots = gsap.utils.toArray('[data-dots]');
  dots.forEach((dot) => {
    gsap.to(dot, {
      scrollTrigger: {
        trigger: dot,
        start: 'top 10%',
        end: '+=3700',
        scrub: true,
        pinSpacing: false,
        pin: true,
      },
    });
  });

  // Mobile Sizes for animations
  let start1, start2, start3;
  if (window.matchMedia('(min-width: 768px)').matches) {
    start1 = 'top 20%';
    start2 = 'top 35%';
    start3 = 'top 50%';
  } else {
    start1 = 'top 25%';
    start2 = 'top 37%';
    start3 = 'top 50%';
  }

  // First Headline //

  ScrollTrigger.create({
    trigger: '[data-scrolling="home-bottom"] [data-statement="1"]',
    start: start1,
    // scrub: true,
    pin: true,
    pinSpacing: false,
    end: '2000%',
  });
  ScrollTrigger.create({
    trigger: '[data-scrolling="home-bottom"] [data-statement="3"]',
    start: start2,
    scrub: true,
    pin: true,
    pinSpacing: false,
    end: '1200%',
  });
  ScrollTrigger.create({
    trigger: '[data-scrolling="home-bottom"] [data-statement="5"]',
    start: start3,
    scrub: true,
    pin: true,
    pinSpacing: false,
    end: '700%',
  });

  // Control each of the home page byline statements in the bottom section of the page //
  const homeStatementFunc = (target, start, end, spacing) => {
    gsap.fromTo(
      target,
      {
        opacity: 1,
        y: 40,
      },
      {
        scrollTrigger: {
          trigger: target,
          start: start,
          end: end,
          scrub: true,
          pin: true,
          pinSpacing: spacing,
        },
        opacity: 0,
        y: 0,
      },
    );
  };

  homeStatementFunc('[data-statement="2"]', 'top 15%', '100%', false);
  homeStatementFunc('[data-statement="4"]', 'top 20%', '100%', false);
  homeStatementFunc('[data-statement="6"]', 'top 25%', '100%', false);
};
